import { FC } from 'react';
import { WarrantyParts2 } from './WarrantyParts2/WarrantyParts2';
import { store } from '@/config/store';
import {
  findDefectAppendWarranty,
  getWarrantyPartsData,
  WarrantyPartsType,
} from '@/utils/warranty';

export const WarrantyParts2Page: FC = () => {
  const { currentWarranty } = store.state;
  const appendWarranty = findDefectAppendWarranty(currentWarranty);
  const warrantyParts: WarrantyPartsType = appendWarranty?.m_warranty_parts
    ? getWarrantyPartsData(appendWarranty?.m_warranty_parts)
    : [];
  return (
    <WarrantyParts2
      appendWarranty={appendWarranty}
      warrantyParts={warrantyParts}
    />
  );
};
